import { render, staticRenderFns } from "./AboutList.vue?vue&type=template&id=8fafb5f4&scoped=true"
import script from "./AboutList.vue?vue&type=script&lang=js"
export * from "./AboutList.vue?vue&type=script&lang=js"
import style0 from "./AboutList.vue?vue&type=style&index=0&id=8fafb5f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fafb5f4",
  null
  
)

export default component.exports